/**
 * Kalimat penyerta deretan foto bukti — MURNI.
 *
 * Dipisah dari komponennya karena inilah bagian yang tidak boleh berbohong. Foto bukti dibaca
 * saat ada sengketa pengiriman, dan pada saat itu selisih antara "tiga foto" dan "tiga foto, satu
 * tidak dapat dimuat" adalah selisih antara catatan yang utuh dan catatan yang bolong.
 */

export interface ProofCaption {
  readonly teks: string;
  /** Benar bila ada yang tidak tampil — pemanggil memberinya nada peringatan, bukan redup. */
  readonly bermasalah: boolean;
}

/**
 * @param total  berapa foto yang TERCATAT di server
 * @param tampil berapa yang benar-benar berhasil ditampilkan
 */
export function proofCaption(total: number, tampil: number): ProofCaption {
  const t = Math.max(0, Math.trunc(total));
  /*
   * Hanya batas BAWAH yang dijaga. Batas atas sempat ada, lalu dibuang: bila `tampil` melebihi
   * `total`, `gagal` menjadi negatif, cabang "sebagian" tidak berjalan, dan kalimatnya sama saja
   * — penjepit yang tidak pernah mengubah keluaran apa pun. Sabotase membuktikannya: mencabutnya
   * tidak memerahkan satu uji pun. Yang tidak dapat diuji tidak dipertahankan.
   *
   * Batas bawah lain ceritanya — `tampil` negatif akan mencetak "-1 dari 3", dan ada ujinya.
   */
  const ada = Math.max(0, Math.trunc(tampil));
  const gagal = t - ada;

  if (t === 0) return { teks: '', bermasalah: false };

  /*
   * Semua gagal. Kalimatnya menegaskan fotonya ADA — tanpa itu, ruang kosong terbaca sebagai
   * "kurir tidak memotret": tuduhan yang dibuat kegagalan teknis terhadap orang yang sudah
   * mengerjakan bagiannya.
   */
  if (ada === 0) {
    return {
      teks: `${t} foto bukti tercatat, tetapi tidak dapat dimuat. Fotonya ADA — coba muat ulang halaman.`,
      bermasalah: true,
    };
  }

  /*
   * Sebagian gagal — dan ini yang paling penting untuk disebut. Menampilkan empat foto tanpa
   * menyebut yang kelima membuat pembacanya menyimpulkan hanya ada empat, lalu mengambil
   * keputusan atas catatan yang ia kira lengkap.
   */
  if (gagal > 0) {
    return {
      teks: `${ada} dari ${t} foto bukti · ${gagal} tidak dapat dimuat`,
      bermasalah: true,
    };
  }

  return { teks: `${t} foto bukti · ketuk untuk melihat penuh`, bermasalah: false };
}
